import { setIsFoDisclosureRequired, updateFoDisclosureRequired } from "../reducers/foDisclosure";
import { update_fo_disclosure } from '../../apis/kyc';
import { call, put, takeEvery } from 'redux-saga/effects';
import { setActionLoaderFalse, setActionLoaderTrue } from "../reducers/actionLoader";
import { setActionError } from "../reducers/actionError";
import { noop } from "lodash-es";

export default function* handleKycSaga() {
    yield takeEvery(updateFoDisclosureRequired.toString(), handleUpdateFoDisclosureRequired);
}

function* handleUpdateFoDisclosureRequired({ payload }) {
    const  { screen, sagaCallback = noop, Api, token } = payload;
    try {
        yield put(setActionLoaderTrue(updateFoDisclosureRequired));
        const body = {
            "source": "login"
        }
        const response = yield call(update_fo_disclosure, { Api, body, token });
        yield put(setIsFoDisclosureRequired(false));
        yield call(sagaCallback, response);
    } catch (error) {
        console.log("error is", error);
        yield put(setActionError({ actionName: updateFoDisclosureRequired, isFetchFailed: true, message: error.message }));
        yield call(sagaCallback, {});
    } finally {
        yield put(setActionLoaderFalse(updateFoDisclosureRequired));
    }
}